import React from 'react';
import { QuoteForm } from '../../forms';

export function CustomQuote({ siteData }) {
    return (
        <section id="custom-quote" className="full-section background hero light-blue-bg mb-5">
            <div className="container">
                <div id="quote-header">
                    <h1 className="milan-text-primary text-uppercase text-center">Get a Custom Quote</h1>
                </div>
                <div className="row justify-content-center">
                    <div className="quote-wrapper col-lg-10 mx-auto py-3 bg-white shadow rounded">
                        <QuoteForm siteData={siteData} />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CustomQuote;
